// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

import {
  UPLOAD_FIELD_BORDERS,
  UPDATE_FIELD_BORDER_OPERATION,
} from './constants'

export function uploadFieldBorders (payload: Object): Action<> {
  return {
    type: UPLOAD_FIELD_BORDERS,
    payload,
  }
}

export function updateFieldBorderOperation (payload: Object): Action<> {
  return {
    type: UPDATE_FIELD_BORDER_OPERATION,
    payload,
  }
}
